import { render } from "./FormProfessionalInfo.vue?vue&type=template&id=ab8ef4ae&scoped=true"
import script from "./FormProfessionalInfo.vue?vue&type=script&lang=js"
export * from "./FormProfessionalInfo.vue?vue&type=script&lang=js"

import "./FormProfessionalInfo.vue?vue&type=style&index=0&id=ab8ef4ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab8ef4ae"]])

export default __exports__